import { Description, MoreHoriz, Videocam } from '@mui/icons-material'
import { Box, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'
import FiletypeIcon from '../../../backoffice/library/ui/components/FiletypeIcon'
import useScreenWidth from '../../hooks/useScreenWidth'
import HiddenDesktop from '../../styles/HiddenDesktop'
import * as ResourceStyles from '../../styles/ResourceStyle'
import * as VipStyles from '../../styles/VipStyles'
import TooltipCards from '../TooltipCards'

type SupportFileProps = {
  data: any
  type: 'lessons' | 'seminarlessons' | 'offers'
  vipContent: boolean
  hasaccess: boolean
  handleEdit?: (value: any) => void
  handleDownload?: (value: string) => void
  handleDelete?: (value: number) => void
}

function SupportFile({ data, type, vipContent, hasaccess = false, handleEdit, handleDownload, handleDelete }: SupportFileProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const [anchorOp, setAnchorOp] = useState<null | HTMLElement>(null)
  const [openOptions, setOpenOptions] = useState(false)

  const handleCloseOptions = () => {
    setAnchorOp(null)
    setOpenOptions(false)
  }

  const TypeFile = () => {
    const fileNameExtension = data.ext === null ? '' : data.ext.toUpperCase()

    const $imageExtensions = ['JPG', 'GIF', 'PNG', 'JPEG', 'BMP', 'TIF']
    const $videoExtensions = ['MP4', 'MOV', 'WMV', 'AVI']

    if ($imageExtensions.includes(fileNameExtension) || data.cover !== null) {
      const tmpFilename = data.cover === null || data.cover === undefined ? data.file_name : data.cover
      return (
        <ResourceStyles.MediaContainer
          sx={{
            background: `${encodeURI(`url(${import.meta.env.VITE_AWS_URL}/${type}/${tmpFilename})`)}`
          }}
          title={data.file_name}
        >
          {vipContent && (
            <VipStyles.VipLabel sx={{ textAlign: 'center' }}>
              <Typography variant={isMobile ? 'body1' : 'subtitle1'}>VIP</Typography>
            </VipStyles.VipLabel>
          )}
        </ResourceStyles.MediaContainer>
      )
    }

    if ($videoExtensions.includes(fileNameExtension)) {
      return (
        <ResourceStyles.MediaContainer>
          <Videocam fontSize="large" color="inherit" />
          {vipContent && (
            <VipStyles.VipLabel sx={{ textAlign: 'center' }}>
              <Typography variant={isMobile ? 'body1' : 'subtitle1'}>VIP</Typography>
            </VipStyles.VipLabel>
          )}
        </ResourceStyles.MediaContainer>
      )
    }

    return (
      <ResourceStyles.MediaContainer>
        <Description fontSize="large" color="inherit" />
        {vipContent && (
          <VipStyles.VipLabel sx={{ textAlign: 'center' }}>
            <Typography variant={isMobile ? 'body1' : 'subtitle1'}>VIP</Typography>
          </VipStyles.VipLabel>
        )}
      </ResourceStyles.MediaContainer>
    )
  }

  return (
    <>
      <Grid item xs={6} sm={4} md={useScreenWidth(1000) ? 6 : 4} lg={3} className="websiteResource">
        <ResourceStyles.ResourceCard sx={{ boxShadow: vipContent ? '0px 4px 32px 0px rgba(230, 185, 128, 0.3) !important' : undefined }}>
          <TypeFile />

          <ResourceStyles.ResourceText>
            <ResourceStyles.Title>
              <HiddenDesktop>
                <FiletypeIcon id={data.filetype_id} />
              </HiddenDesktop>
              <TooltipCards titleCard={data.alias && true ? data.alias : data.file_name} classNameCustom="resourceTitle" />
            </ResourceStyles.Title>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton
                id={`icon-button-${data.id}`}
                onClick={(event: MouseEvent<HTMLButtonElement>) => {
                  setAnchorOp(event.currentTarget)
                  setOpenOptions(true)
                }}
              >
                <MoreHoriz />
              </IconButton>
            </Box>
          </ResourceStyles.ResourceText>
        </ResourceStyles.ResourceCard>

        {/* Hidden content vip */}
        {vipContent && !hasaccess && (
          <VipStyles.VipBlock sx={{ alignContent: 'center', textAlign: 'center' }}>
            <Typography variant="subtitle1" color="inherit">
              {t('this-is-a-content')}
            </Typography>
            <Typography variant="h5" color="inherit">
              VIP
            </Typography>
          </VipStyles.VipBlock>
        )}
      </Grid>

      <Menu
        id={`simple-menu-${data.id}`}
        anchorEl={anchorOp}
        keepMounted
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={openOptions}
        onClose={handleCloseOptions}
        onClick={handleCloseOptions}
      >
        {handleEdit !== undefined && authUser !== null && [1, 2, 5].includes(authUser.role_id) && (
          <MenuItem onClick={() => handleEdit(data)}>{t('edit')}</MenuItem>
        )}
        {handleDownload && <MenuItem onClick={() => handleDownload(data.file_name)}>{t('download')}</MenuItem>}

        {(type === 'lessons' || type === 'seminarlessons') && authUser !== null && [1, 2, 5].includes(authUser.role_id) && handleDelete && (
          <MenuItem onClick={() => handleDelete(data.id)}>{t('delete')}</MenuItem>
        )}
      </Menu>
    </>
  )
}

export default SupportFile
